/**
 * Detektiert ob das Modul in einer Next.js Umgebung läuft
 */
export const isRouterEnvironment = (env: 'next-js'): boolean => {
    if (!env) return false;
    if (typeof window === 'undefined') return false;

    if (env === 'next-js') {
        // Next.js fügt __NEXT_DATA__ dem window-Objekt hinzu
        return '__NEXT_DATA__' in window ||
            // Alternative: Check für Next.js Router
            '__NEXT_ROUTER_BASEPATH' in window;
    }
};